import { forwardRef, ReactNode } from "react";
import Form from "react-bootstrap/Form";
import { FormCheckProps } from "react-bootstrap/FormCheck";
import styles from "./ToggleSwitch.module.css";
import { v4 as uuidv4 } from "uuid";
import useResponsive from "../../../hooks/useResponsive";

export type ToggleSwitchProps = {
  on?: boolean;
  onLabel?: ReactNode;
  offLabel?: ReactNode;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & Omit<FormCheckProps, "type" | "id">;

const ToggleSwitch = forwardRef(
  (
    {
      on,
      onLabel = "On",
      offLabel = "Off",
      onChange,
      disabled,
      ...rest
    }: ToggleSwitchProps,
    ref
  ) => {
    const id = uuidv4();
    const { isTabletPortrait } = useResponsive();
    return (
      <div
        className={`${styles.switch} ${
          disabled ? styles.disabled : ""
        } d-flex align-items-center`}
      >
        <Form.Group
          controlId={id}
          className={`${styles.switch} ${
            disabled ? styles.disabled : ""
          } d-flex align-items-center mb-0 `}
        >
          <Form.Label
            className={`mb-0 mx-2 ${styles.label} ${!on ? styles.active : ""}`}
          >
            {offLabel}
          </Form.Label>
          <Form.Switch
            className={`${isTabletPortrait && "mb-2"}`}
            ref={ref}
            id={id}
            onChange={onChange}
            checked={on ?? false}
            disabled={disabled}
            {...rest}
          />
          <Form.Label
            className={`mb-0 ${isTabletPortrait && "mx-2"} ${styles.label} ${
              on ? styles.active : ""
            }`}
          >
            {onLabel}
          </Form.Label>
        </Form.Group>
      </div>
    );
  }
);

export default ToggleSwitch;
